import React from "react";

import Logo from "@/shared/components/Logo";

/* The chrome-less page frame, mirroring `features/home/Onboarding.tsx`: the
   mark alone in the top-left, everything else centred on the recessed canvas.
   Shared by the login/signup card and the callback's loading state so the two
   are the same page with different middles — no jump across the redirect. */
export default function AuthFrame({ children }: { children: React.ReactNode }) {
  return (
    <div className="h-screen w-screen bg-[var(--surface-sunk)] text-[var(--text-primary)] flex flex-col overflow-y-auto">
      <div className="shrink-0 px-6 py-5">
        <Logo />
      </div>
      <div className="flex-1 flex items-center justify-center px-4 pb-16">{children}</div>
    </div>
  );
}
